const styles = {
  containerStyle: {
    // height: '95vh'
    backgroundColor: '#EDF3FC'
  },
  contentStyle: {
    display: 'flex',
    flexDirection: 'row',
    // alignItems: 'center',
    justifyContent: 'center',
    // boxShadow: 1,
    // maxWidth: 1273,
    // border: 1,
    my: 1
    // mx: 2
    // backgroundColor: '#FFFFFF'
  },
  leftFormCardContainerStyle: {
    display: 'flex',
    // borderRight: 1,
    // borderLeft: 1,
    boxShadow: 0,
    boxShadowBottom: 0,
    borderColor: '#747678',
    flexDirection: 'column',
    // alignItems: 'center',
    // justifyContent: 'center',
    // width: 1273,
    background: '#FFFF',
    width: 343
    // mr: 2,
    // height: '80vh'
  },
  rightFormCardContainerStyle: {
    display: 'flex',
    border: 0,
    boxShadow: 0,
    borderColor: '#747678',
    flexDirection: 'column',
    // alignItems: 'center',
    // justifyContent: 'center',
    // width: 1273,
    background: '#FFFF',
    width: 930
    // height: '80vh'
  },
  headerStyle: {
    backgroundColor: '#003087',
    height: 100
  },
  headerContainer: {
    alignItems: 'center',
    justifyContent: 'center'
  },
  headerText: {
    fontSize: 24,
    color: '#F7F7F7',
    fontFamily: 'Lobster-Regular'
  },
  icon: {
    flexDirection: 'row'
  },
  headerHourText: {
    fontSize: 12,
    color: '#8094B9',
    fontWeight: '600'
  },
  footerStyle: {
    backgroundColor: '#F7F7F7',
    marginTop: 1
  },
  messageContainer: {
    // border: 3,
    // borderColor: '#000000',
    // marginTop: 0,
    // backgroundColor: '#EDF3FC',
    // marginBottom: 0,
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center'
    // height: '10vh'
  },
  titleText: {
    marginTop: 20,
    marginBottom: 10,
    textAlign: 'center',
    fontSize: 20,
    color: '#021D4E',
    fontWeight: '600'
  },
  titleStyle: {
    marginTop: 20,
    //  marginLeft: 20,
    fontSize: 16,
    color: '#021D4E',
    noWrap: true,
    fontWeight: '500'
    //marginBottom: 20
  },

  stepLabelStyle: {
    // marginTop: 20,
    //  marginLeft: 20,
    fontSize: 14,
    color: '#021D4E',
    noWrap: true,
    fontWeight: '500'
    //marginBottom: 20
  },
  stepLabelLinkStyle: {
    // marginTop: 20,
    //  marginLeft: 20,
    fontSize: 14,
    color: '#000000',
    noWrap: true,
    textDecorationLine: 'underline',
    fontWeight: '800'
    //marginBottom: 20
  },
  profileStyle: {
    marginTop: 10,
    //  marginLeft: 20,
    fontSize: 20,
    color: 'blue',
    fontWeight: '500'
    //marginBottom: 20,
  },
  nameStyle: {
    // marginTop: 20,
    //marginLeft: 20,
    fontSize: 18,
    color: '#021D4E',
    fontWeight: '520'
    //marginBottom: 40,
  },

  buttonContainer: {
    backgroundColor: 'white',

    marginLeft: 50,
    //marginBottom: 35,
    marginRight: 50
  },
  buttonStyle: {
    borderRadius: 5,
    //backgroundColor: '',
    width: 300
  },
  buttonText: {
    color: '#021D4E',
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center'
  },
  callText: {
    fontSize: 13,
    color: '#FFFFFF',
    fontWeight: '600',
    marginLeft: 5
  },
  subTitleStyle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    my: 1,
    fontSize: 18,
    fontWeight: '500'
  },
  blockContainerStyle: {
    my: 0,
    mx: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    border: 0
    //width: 300
  },
  errorText: {
    color: '#d32f2f',
    fontWeight: 'normal',
    fontSize: 16,
    marginBottom: 10,
    marginTop: 0,
    textAlign: 'left',
    marginLeft: 10
  },
  linkItemStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    border: 0,
    mt: 2,
    mb: 4
  },
  formCardButtonStyle: {
    mt: 4,
    mb: 5,
    width: 350
  },
  linkTextStyle: {
    color: '#003087'
  },
  inputRoot: {
    fontSize: 20
  },
  labelRoot: {
    fontSize: 20,
    color: 'red',
    '&$labelFocused': {
      color: 'purple'
    }
  },
  labelFocused: {},
  containerStyle2: {
    height: '93vh',
    backgroundColor: '#EDF3FC'
  },
  contentStyle2: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    // minWidth: 600,
    border: 0,
    my: 8
  },
  formCardContainerStyle: {
    display: 'flex',
    border: 0,
    boxShadow: 1,
    borderColor: '#747678',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: 450,
    padding: 4,
    background: '#FFFF'
  },
  formCardButtonStyle2: {
    mt: 4,
    mb: 5,
    flex: 1,
    width: 350
  },
  formCardTitleStyle: {
    my: 4,
    mx: 4,
    alignItems: 'center',
    justifyContent: 'center'
  },
  helperText: {
    fontSize: 14,
    color: '#747678'
  }
};

export default styles;
